import axios from 'axios'
import apiConfig from '../config/api.js'

// Criar instância do axios com configurações base
const api = axios.create({
  baseURL: apiConfig.baseURL,
  timeout: 90000,
  headers: {
    'Content-Type': 'application/json'
  }
})

// Interceptor para adicionar token de autenticação
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token')
    if (token) {
      config.headers.Authorization = token
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// Interceptor para tratar respostas e erros
api.interceptors.response.use(
  (response) => {
    return response
  },
  (error) => {
    // Se o token expirou ou é inválido, redirecionar para login
    if (error.response?.status === 401) {
      localStorage.removeItem('token')
      localStorage.removeItem('isSuperUser')
      localStorage.removeItem('username')
      
      // Só redirecionar se não estiver em páginas públicas
      const publicPages = ['/login', '/quote-request', '/confirmation', '/quote-view']
      const isPublicPage = publicPages.some(page => window.location.pathname.startsWith(page))
      
      if (!isPublicPage) {
        window.location.href = '/login'
      }
    }
    return Promise.reject(error)
  }
)

export default api
